export enum BannerEnum {
  BOOK = 'BOOK',
  POSTER = 'POSTER',
}
